import { render, staticRenderFns } from "./divier.vue?vue&type=template&id=51d401a6&scoped=true&"
import script from "./divier.vue?vue&type=script&lang=js&"
export * from "./divier.vue?vue&type=script&lang=js&"
import style0 from "./divier.vue?vue&type=style&index=0&id=51d401a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d401a6",
  null
  
)

export default component.exports